module.exports = __webpack_public_path__ + "assets/img/SpinTel-Pillar-Page-Resource-w720.5a7be43a.jpg";